import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/db1d3804-91f4-40f6-a3c5-fc4e734519fd";
export const REGISTER_URL = "https://a.ntrk2.com/e7f7d362-9e37-4263-9ede-d94fac4a1dae";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://bigwinph.kzw2a.com/download?openExternalBrowser=1&id=vlwkyz8j8tayool";

export * from "./codes";
export * from "./context";
